export const UsersData = [
    {
        fullName:"Akua Konadu",
        id:"1234",
        image:"Akua.png",
        message:"Great man of God in our time",
        email: "example@gmail.com"
    },
    {
        fullName:"Akua Konadu",
        id:"1234",
        image:"Akua.png",
        message:"God bless you you Papa",
        email:"example@gmail.com"
    },
    {
        fullName:"Akua Konadu",
        id:"1234",
        image:"Akua.png",
        message:"God bless you you Papa",
        email:"example@gmail.com"
    },
    {
        fullName:"Akua Konadu",
        id:"1234",
        image:"Akua.png",
        message:"God bless you you Papa",
        email:"example@gmail.com"
    },
    {
        fullName:"Akua Konadu",
        id:"1234",
        image:"Akua.png",
        message:"God bless you you Papa",
        email:"example@gmail.com"
    },
    {
        fullName:"Akua Konadu",
        id:"1234",
        image:"Akua.png",
        message:"God bless you you Papa",
        email:"example@gmail.com"
    },
    {
        fullName:"Akua Konadu",
        id:"1234",
        image:"Akua.png",
        message:"God bless you you Papa",
        email:"example@gmail.com"
    },
]